import Text from '@service-victoria/component-library/components/Text';
import { useAppContext } from 'context/app';
import { AddAvailability } from 'interfaces/store';
import React from 'react';
import { Spacer24 } from 'steps/styled';
import * as Styled from './styled';

type TooEarlyProps = {
  updateAvailability: AddAvailability;
};

function timeUntilMidday(startTime?: string) {
  const currentDateTime = new Date();
  const middayRelease = new Date(startTime || '');

  const diffInTime = middayRelease.getTime() - currentDateTime.getTime();
  const diffHours = Math.max(0, Math.floor(diffInTime / (1000 * 3600)));
  const diffMins = Math.ceil((diffInTime / (1000 * 60)) % 60);

  if (diffMins < 0) return `00hrs 00mins`;

  const prependZero = (number: number) => (number < 10 ? `0${number}` : `${number}`);

  return `${prependZero(diffHours)}hrs ${prependZero(diffMins)}min${diffMins !== 1 ? 's' : ''}`;
}

export default function TooEarly({ updateAvailability }: TooEarlyProps) {
  const { currentState } = useAppContext();
  const [timeToRender, setTimeToRender] = React.useState<string>('');

  React.useEffect(() => {
    setTimeToRender(timeUntilMidday(currentState.startTime));

    const timer = setInterval(() => {
      const timeToRender = timeUntilMidday(currentState.startTime);
      setTimeToRender(timeToRender);

      if (timeToRender === '00hrs 00mins') {
        updateAvailability('SUCCESS', currentState.startTime);
        clearInterval(timer);
      }
    }, 5000);
    return () => {
      clearInterval(timer);
    };
  }, [currentState.startTime, updateAvailability]);

  return (
    <>
      <Text.Heading.H2 style={{ fontWeight: 600 }}>You&apos;re early.</Text.Heading.H2>
      <Text.Body>
        The Victorian Government’s $14.5 million COVIDSafe Outdoor Activation Voucher Program will
        provide more than 7000 Victorian businesses, community organisations, not-for-profits and
        trader associations with vouchers for $2000 to support initiatives such as outdoor
        hospitality and entertainment.
      </Text.Body>
      <Text.Body>
        The COVIDSafe Outdoor Activation Voucher Program will assist businesses across the state to
        move outdoors by supporting their investment in equipment, permits and other tools needed to
        offer safe retail, personal services, recreation and dining options for the Victorian public
        during the remainder of 2021 and beyond.
      </Text.Body>
      <Text.Body>
        The program will be launching soon. Please revisit this page for updates.
      </Text.Body>
      <Text.Body>
        Please come back in{' '}
        <Text.Heading.H2 as='span' style={{ display: 'inline-block' }}>
          {timeToRender}
        </Text.Heading.H2>
      </Text.Body>
      <Text.Body>
        Want to be ready on the day? Make sure you have your Victorian driver licence, or seniors
        card or proof-of-age card handy. You&apos;ll need it to complete your application.
      </Text.Body>
      <Spacer24 />
      <Styled.TextBodyWithInlineLink>
        While you&apos;re waiting,{' '}
        <Text.Link
          value='read more about the scheme'
          href='https://www.vic.gov.au/covidsafe-outdoor-activation-voucher-program'></Text.Link>{' '}
        and what you can claim.
      </Styled.TextBodyWithInlineLink>
    </>
  );
}
